import { useAuth0 } from '@auth0/auth0-react';
import Button from '@mui/material/Button';
import { useEffect } from 'react';
import { BooleanParam, useQueryParams } from 'use-query-params';

const LoginButton: React.FC = () => {
  const { loginWithRedirect, logout, error } = useAuth0();
  const [query] = useQueryParams({
    afterError: BooleanParam,
  });

  // Automatically login if redirected after an error.  This way the user presses the login button which logs them out, it redirects and adds the param that an error occurred, and then auto triggers the login form to show again instead of having to press the login button again.
  useEffect(() => {
    if (query.afterError) {
      loginWithRedirect();
    }
  }, [query, loginWithRedirect]);

  const handleClick = () => {
    // If error, logout first, then redirect to login with afterError flag
    if (error) {
      logout({ returnTo: `${window.location.origin}/login?afterError=1` });
    } else {
      loginWithRedirect();
    }
  };

  return (
    <Button
      variant='contained'
      size='large'
      color='secondary'
      sx={{
        width: '100%',
        maxWidth: '20rem',
        whiteSpace: 'nowrap',
      }}
      onClick={handleClick}
    >
      Login
    </Button>
  );
};

export default LoginButton;
